//数据看板 --分析课程学习
import request from '@/utils/request'
const apiPath = '/dashboard/teev2'
const DataBoardV2Api = {
  // //数据看板 --分析课程学习
  learningAnalysisCourse(query) {
    return request.get(apiPath + '/statisticsCourseStudy', { params: query })
  }
}
export default DataBoardV2Api